var _style, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpxLinqColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 913.79 209.52",
    style: {
      enableBackground: "new 0 0 913.79 209.52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#002856;stroke:#76BC21;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:#002856;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M527.88,24.71l-65.84,80.7l68.28,83.36h364.24V53c0-15.5-12.56-28.07-28.06-28.07 C780.71,24.93,527.69,24.9,527.88,24.71z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.23,24.98h18.82l66.15,100.14l66.46-100.14h18.52v163.57h-20.03V60.79L109.2,157.6L44.25,60.79v127.76 H24.23V24.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.76,24.98h93.76c32.18,0,51.31,16.99,51.31,44.31c0,27.31-17.92,47.65-48.58,47.65h-76.17v71.62h-20.32 V24.98z M307.31,97.82c20.64,0,31.26-9.41,31.26-26.7c0-16.99-10.62-27.31-30.35-27.31h-73.14v54.02H307.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.51,106.32l-65.86-81.34h24.89l53.72,65.56l53.42-65.56h24.58L443.4,105.4l67.69,83.16h-26.1l-54.33-67.37 l-54.93,67.37h-23.96L418.51,106.32z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M537.52,57.32h15.27v83.81h54.93v14.07h-70.19V57.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M616.94,57.32h15.27v97.88h-15.27V57.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M645.31,95.94c0-24.84,14.82-40.56,41.31-40.56c26.64,0,41.46,15.72,41.46,40.56v59.27h-15.27V95.94 c0-16.46-8.98-26.49-26.19-26.49c-17.06,0-26.04,10.03-26.04,26.49v59.27h-15.27V95.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M765.42,71.15l9.75,1.23c4.8-2.15,10.25-3.36,16.23-3.36c12.51,0,22.78,5.15,29.29,13.55l2.04-9.83l12.46,3.9 c-9.09-13.42-24.7-21.8-43.8-21.8c-8.58,0-16.45,1.69-23.34,4.77L765.42,71.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M823.46,147.99c4.66-3.59,8.66-8.64,8.77-8.77c7.16-8.69,11.66-20.71,11.66-33.1c0-7.52-1.41-14.53-4.01-20.8 l-11.93-3.74l-2.12,10.2c1.64,4.36,2.53,9.18,2.53,14.34c0,8.62-2.26,16.45-6.82,22.4c-1.02,1.33-3.74,4.53-8.14,8.07 c0.03-0.04,10.92-1.25,11.92-1.3L823.46,147.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M757.81,134.63l0.79-10.56c-2.78-5.52-4.15-11.72-4.15-17.94c0-11.48,4.37-21.29,11.76-27.94l-9.19-1.16 l2.93-12.84c-13.08,9.07-21.03,24.07-21.03,41.94c0,9.84,2.48,18.8,6.81,26.38L757.81,134.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M853.54,167.76l-5.72-11.98c-0.24-0.49-0.84-0.66-1.3-0.37c-5.26,3.26-11.55,4.96-17.13,4.96 c-3.47,0-7.19-0.45-10.15-2.41c-2.93-1.94-4.03-5.41-6.53-7.86c-3.67-3.59-8.51-5.98-13.59-6.75c-4.65-0.7-9.34,0.11-14.04-0.59 c-7.62-1.13-14.79-4.54-20.23-9.99l-0.75,9.94l-12.71-2.23c9.19,10.52,22.7,16.89,37.95,16.89c0.14,0,2.34,0.02,2.48,0.01 c3.83-0.03,7.45,1.86,9.38,5.17c5.08,8.69,14.2,13.11,27.31,13.11c9.23,0,17.47-2.14,24.71-6.83 C853.59,168.62,853.72,168.15,853.54,167.76z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpxLinqColor);
export default __webpack_public_path__ + "static/media/MPXLinq_Color.4483cdefcaf2d2768d67019554f808eb.svg";
export { ForwardRef as ReactComponent };